import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
import VueRouter from 'vue-router';
import App from './App.vue'
import router from './router';
import store from './store/store';
import http from './utils/http';
import moment from 'moment';
import {
	Message,
	Loading
} from 'element-ui';
import {
	directive as onClickAway
} from 'vue-clickaway';
import jtingView from '@/components/pubComponents/jtingView.vue';
import fullscreen from 'vue-fullscreen'
import VueSmoothScroll from "vue2-smooth-scroll";

Vue.component('jting-button', jtingView);

Vue.directive('clickaway', onClickAway);

Vue.filter('momentYR', (val, formatString) => {
	if (!val) {
		return ''
	}
	formatString = formatString || 'YYYY-MM-DD';
	return moment(val).format(formatString)
})
Vue.filter('momentZ', (val) => {
	if (!val) {
		return ''
	}
	// 获取当前日期
	const currentDate = moment(val);

	// 获取周几的数字表示（0-6，0是周日）
	const dayOfWeekNumber = currentDate.day();

	// 将数字转换为中文周几
	const dayOfWeekChinese = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][dayOfWeekNumber];
	return dayOfWeekChinese
})

// 创建audio元素
const globalAudio = new Vue({
	data() {
		return {
			audio: null
		}
	},
	created() {
		this.audio = new Audio();
	},
	methods: {
		init(src, fn) {
			this.audio.addEventListener('ended', fn)
			this.audio.src = src;
		},
		playbackRate(num) {
			// 倍速
			this.audio.playbackRate = num;
		},
		playvolume(num) {
			// 调整音量
			this.audio.volume = num;
		},
		resetFn() {
			this.audio.currentTime = 0;
		},
		rewind() {
			this.audio.currentTime -= 5;
		},
		fastForward() {
			this.audio.currentTime += 5;
		},
		tiemFn() {
			return Math.floor(this.audio.duration)
		},
		jumpToHalf(num) {
			if (this.audio) {
				this.audio.currentTime = num; // 跳转到一半的位置
			}
		},
		endedFn(item) {
			if (this.audio) {
				this.audio.addEventListener('ended', () => {
					item.bfFlag = false
				})
			}
		},
		play() {
			if (this.audio) {
				this.audio.play();
			}
		},
		pause() {
			if (this.audio) {
				this.audio.pause();
			}
		},
		times() {
			const duration = Math.floor(this.audio.duration); // 总时长
			const currentTime = Math.floor(this.audio.currentTime); // 当前播放时间
			const remaining = duration - currentTime; // 计算剩余时间
			return remaining
		}
	}
})
// 将audio元素添加到Vue原型上
Vue.prototype.$audio = globalAudio;
// 缓存

Vue.prototype.$extractText = function(htmlString) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlString, 'text/html');
	return doc.body.textContent.replace(/&nbsp;/g, '') || ""; // 使用textContent获取文本内容
}
Vue.prototype.$removeSty = function(htmlString) {
	return htmlString.replace(/ style="[^"]*"/g, '') || ""; // 使用textContent获取文本内容
}

function numberToChinese(num) {
	const map = {
		'0': '零',
		'1': '一',
		'2': '二',
		'3': '三',
		'4': '四',
		'5': '五',
		'6': '六',
		'7': '七',
		'8': '八',
		'9': '九'
	};
	return String(parseInt(num, 10)).replace(/\d/g, digit => map[digit]);
}
Vue.prototype.$jgZfn = function(txt) {
	console.log(txt)
	if (!txt) {
		return
	}
	let str = ''
	const regex = /【([^】]*)】/;
	if (regex.test(txt)) {
		const match = txt.match(/【(\d+)】/);
		let number = match ? match[1] : null;
		if (txt.includes('Q')) {
			for (let i of number) {
				str += `对话一文${numberToChinese(i)}答，`
			}
		} else if (txt.includes('D')) {
			for (let i of number) {
				str += `独白一文${numberToChinese(i)}答，`
			}
		}
	} else {
		let as = txt.match(/\d+[A-Z]/g)
		console.log(as)
		as.forEach(item => {
			if (item.includes('Q')) {
				str += `对话一文${numberToChinese(item)}答，`
			} else if (item.includes('D')) {
				str += `独白一文${numberToChinese(item)}答，`
			}
		})
	}
	return str
}

Vue.directive('prevent-click', {
	bind(el) {
		el.addEventListener('click', event => {
			event.stopPropagation(); // 阻止点击事件向上冒泡
			event.preventDefault(); // 阻止默认行为
		}, true); // 设置为捕获模式
	}
});

//防止连续点击
Vue.directive(
	'preventReclick', {
		inserted(el, binding) {
			el.addEventListener('click', () => {
				if (!el.disabled) {
					el.disabled = true
					setTimeout(() => {
						el.disabled = false
					}, binding.value || 2000)
				}
			})
		}
	})

// 注册自定义指令
// Vue.directive('conditional-title', {
// 	bind: function(el, binding) {
// 		// 保存原始文本内容
// 		el._originalText = el.textContent;

// 		// 检测函数
// 		const checkOverflow = () => {
// 			const isOverflowing = el.scrollWidth > el.clientWidth;

// 			if (isOverflowing) {
// 				el.setAttribute('title', el._originalText);
// 				el.classList.add('has-title');
// 				el.classList.remove('no-title');
// 			} else {
// 				el.removeAttribute('title');
// 				el.classList.add('no-title');
// 				el.classList.remove('has-title');
// 			}

// 			// 触发自定义事件，让Vue实例知道状态变化
// 			const event = new CustomEvent('title-status-change', {
// 				detail: {
// 					hasTitle: isOverflowing,
// 					id: el.id
// 				}
// 			});
// 			el.dispatchEvent(event);
// 		};

// 		// 初始检测
// 		checkOverflow();

// 		// 保存检测函数以便后续使用
// 		el._checkOverflow = checkOverflow;

// 		// 监听窗口大小变化
// 		window.addEventListener('resize', checkOverflow);
// 	},

// 	update: function(el, binding) {
// 		// 如果文本内容发生变化，更新原始文本
// 		if (el.textContent !== el._originalText) {
// 			el._originalText = el.textContent;
// 			el._checkOverflow();
// 		}
// 	},

// 	unbind: function(el) {
// 		// 清理事件监听
// 		window.removeEventListener('resize', el._checkOverflow);
// 	}
// });

// 全局状态存储路由历史（简易版）
const routeHistory = []
let currentIndex = -1

router.beforeEach((to, from, next) => {
	if (globalAudio.audio) {
		globalAudio.audio.pause()
	}
	// const targetPath = to.fullPath
	// const fromPath = from.fullPath

	// // 判断是否为返回操作
	// if (routeHistory[currentIndex - 1] === targetPath) {
	//   currentIndex--
	//   to.meta.isBack = true // 添加元信息标识
	//   console.log('返回操作')
	// } else {
	//   // 新增路径，清空后面的历史（如果有）
	//   routeHistory.splice(currentIndex + 1)
	//   routeHistory.push(targetPath)
	//   currentIndex++
	//   console.log('前进操作')
	//   to.meta.isBack = false
	// }
	next(); // 确认导航
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function(location, onResolve, onReject) {
	window.scrollTo(0, 0)
	if (onReject === undefined) {
		onReject = function() {}
	}
	return originalPush.call(this, location, onResolve, onReject)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function(location, onResolve, onReject) {
	window.scrollTo(0, 0)
	if (onReject === undefined) {
		onReject = function() {}
	}
	return originalReplace.call(this, location, onResolve, onReject)
}

// 创建一个新的Vue实例作为事件总线
const bus = new Vue();

// 将事件总线添加到Vue的原型上，名为$bus
Vue.prototype.$bus = bus;

Vue.use(VueSmoothScroll)
Vue.use(fullscreen)
Vue.use(VueRouter)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$erwUrl = 'data:image/png;base64,' //
Vue.prototype.$httpUrl = 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com' //线上
// Vue.prototype.$httpUrl = 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com'
Vue.prototype.$imgUrl = Vue.prototype.$httpUrl
Vue.prototype.$txtGs = str => {
	if (!str) {
		return ''
	}
	return str.replace(/\n/g, '<br>').replace(/<\/?(img)[^>]*>/gi, '')
}
Vue.prototype.$scFn = (data, isCollect, fn, datas) => {
	if (!isCollect) {
		let loadingInstance = Loading.service({
			lock: true,
		});
		// 收藏
		http.post('api/app/yydCollect', data).then(res => {
			loadingInstance.close();
			if (res.code == 200) {
				Message({
					message: '收藏成功',
					type: 'success'
				})
				fn({
					...datas
				})
			}
		})
	} else {
		// 已收藏
		http.post(`api/app/yydCollect/cancel/${data.type}/${data.assetsId}`).then(res => {
			if (res.code == 200) {
				Message({
					message: '取消成功',
					type: 'success'
				})
				fn({
					...datas
				})
			}
		})
	}
}
// 下载
Vue.prototype.$xzFn = (data, fn) => {
	let loadingInstance = Loading.service({
		lock: true,
	});
	http.get('api/app/common/download', {
		params: {
			token: localStorage.getItem('token'),
			...data
		}
	}).then(res => {
		loadingInstance.close();
		fn(res)
	})
}
Vue.prototype.$pre = {
	lock: true,
	text: '请求中，请稍后...',
	spinner: 'el-icon-loading',
	background: 'rgba(0, 0, 0, 0.7)'
}

// uuid
Vue.prototype.$uuid = function() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0,
			v = c === 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}
// 图标选择
Vue.prototype.$imgFn = function(tit, type) {
	console.log('tit: ',tit);
	if (!tit) {
		return
	}
	let wjArr = ''
	let url = ''
	if (type == 1) {
		if (!localStorage.getItem('wjData')) {
			return
		}
		// 文件
		wjArr = JSON.parse(localStorage.getItem('wjData'))
		
		let isDuochongwenjian = false
		function countOccurrences(str, substring) {
		    // 注意：空字符串需要特殊处理
		    if (substring.length === 0) return 0;
		    
		    // split() 方法会在每次匹配到子字符串时分割
		    // 结果数组长度减1就是出现次数
		    return str.split(substring).length - 1;
		}
		if (tit.includes(',')) {
			let num = 0
			let titTmp = tit
			if (titTmp.includes('.xlsx')) {
				num = num + countOccurrences(titTmp, '.xlsx')
				titTmp = titTmp.replace(/\.xlsx/g, "");
			}
			if (titTmp.includes('.xls')) {
				num = num + countOccurrences(titTmp, '.xls')
				titTmp = titTmp.replace(/\.xls/g, "");
			}
			if (titTmp.includes('.docx')) {
				num = num + countOccurrences(titTmp, '.docx')
				titTmp = titTmp.replace(/\.docx/g, "");
			}
			if (titTmp.includes('.doc')) {
				num = num + countOccurrences(titTmp, '.doc')
				titTmp = titTmp.replace(/\.doc/g, "");
			}
			if (titTmp.includes('.txt')) {
				num = num + countOccurrences(titTmp, '.txt')
				titTmp = titTmp.replace(/\.txt/g, "");
			}
			if (titTmp.includes('.enbx')) {
				num = num + countOccurrences(titTmp, '.enbx')
				titTmp = titTmp.replace(/\.enbx/g, "");
			}
			if (titTmp.includes('.flv')) {
				num = num + countOccurrences(titTmp, '.flv')
				titTmp = titTmp.replace(/\.flv/g, "");
			}
			if (titTmp.includes('.jpg')) {
				num = num + countOccurrences(titTmp, '.jpg')
				titTmp = titTmp.replace(/\.jpg/g, "");
			}
			if (titTmp.includes('.mov')) {
				num = num + countOccurrences(titTmp, '.mov')
				titTmp = titTmp.replace(/\.mov/g, "");
			}
			if (titTmp.includes('.rtf')) {
				num = num + countOccurrences(titTmp, '.rtf')
				titTmp = titTmp.replace(/\.rtf/g, "");
			}
			if (titTmp.includes('.pdf')) {
				num = num + countOccurrences(titTmp, '.pdf')
				titTmp = titTmp.replace(/\.pdf/g, "");
			}
			if (titTmp.includes('.ppt')) {
				num = num + countOccurrences(titTmp, '.ppt')
				titTmp = titTmp.replace(/\.ppt/g, "");
			}
			if (titTmp.includes('.mp3')) {
				num = num + countOccurrences(titTmp, '.mp3')
				titTmp = titTmp.replace(/\.mp3/g, "");
			}
			if (titTmp.includes('.wav')) {
				num = num + countOccurrences(titTmp, '.wav')
				titTmp = titTmp.replace(/\.wav/g, "");
			}
			if (titTmp.includes('.mp4')) {
				num = num + countOccurrences(titTmp, '.mp4')
				titTmp = titTmp.replace(/\.mp4/g, "");
			}
			if (titTmp.includes('.zip')) {
				num = num + countOccurrences(titTmp, '.zip')
				titTmp = titTmp.replace(/\.zip/g, "");
			}
			if (titTmp.includes('.rar')) {
				num = num + countOccurrences(titTmp, '.rar')
				titTmp = titTmp.replace(/\.rar/g, "");
			}
			if (titTmp.includes('.png')) {
				num = num + countOccurrences(titTmp, '.png')
				titTmp = titTmp.replace(/\.png/g, "");
			}
			if (titTmp.includes('.gif')) {
				num = num + countOccurrences(titTmp, '.gif')
				titTmp = titTmp.replace(/\.gif/g, "");
			}
			if (num > 1) {
				isDuochongwenjian = true
			}
		}
		console.log('isDuochongwenjian: ',isDuochongwenjian);
		url = wjArr.filter(item => {
			
			if (isDuochongwenjian) {
			// if (tit.includes(',')) {
				tit = 'xxx.多重文件'
			} else {
				if (tit.includes('xls') || tit.includes('xlsx')) {
					tit = 'xxx.xls'
				}
				if (tit.includes('doc') || tit.includes('docx')) {
					tit = 'xxx.docx'
				}
				if (tit.includes('txt')) {
					tit = 'xxx.txt'
				}
				if (tit.includes('enbx')) {
					tit = 'xxx.enbx'
				}
				if (tit.includes('flv')) {
					tit = 'xxx.flv'
				}
				if (tit.includes('jpg')) {
					tit = 'xxx.jpg'
				}
				if (tit.includes('mov')) {
					tit = 'xxx.mov'
				}
				if (tit.includes('rtf') || tit.includes('pdf')) {
					tit = 'xxx.pdf'
				}
				if (tit.includes('ppt')) {
					tit = 'xxx.pptx'
				}
				if (tit.includes('mp3')) {
					tit = 'xxx.mp3'
				}
				if (tit.includes('wav')) {
					tit = 'xxx.wav'
				}
				if (tit.includes('mp4')) {
					tit = 'xxx.mp4'
				}
				if (tit.includes('zip')) {
					tit = 'xxx.zip'
				}
				if (tit.includes('rar')) {
					tit = 'xxx.rar'
				}
				if (tit.includes('png')) {
					tit = 'xxx.png'
				}
				if (tit.includes('gif')) {
					tit = 'xxx.gif'
				}
			}
			console.log('tit: ',tit);
			return tit.includes('.' + item.name.toLowerCase())
		})[0]?.bannerImg
	} else {
		if (!localStorage.getItem('mtData')) {
			return
		}
		// 媒体
		wjArr = JSON.parse(localStorage.getItem('mtData'))
		url = wjArr.filter(item => {
			return item.name.includes(tit)
		})[0]?.bannerImg
	}
	return Vue.prototype.$imgUrl + url
}
// 类型判断
Vue.prototype.$lxfn = function(tit) {
	let str = ''
	if (tit?.includes('mp3') || tit?.includes('wav')) {
		str += 'meiWecFjFot3'
	}
	if (tit?.includes('mp4') || tit?.includes('mov') || tit?.includes('flv')) {
		str += ' meiWecFjFot2'
	}
	if (tit?.includes('txt') || tit?.includes('doc') || tit?.includes('docx') || tit?.includes('rtf') || tit
		?.includes('pdf') || tit?.includes('ppt') || tit?.includes('pptx') || tit?.includes('xls') || tit?.includes(
			'xlsx')) {
		str += ' meiWecFjFot1'
	}
	return str
}



new Vue({
	render: h => h(App),
	store,
	router,
}).$mount('#app')